import React from 'react';
import classnames from 'classnames';

let timer;

export default function useRowClick(Table){
    return class RowClickTable extends React.Component {

        render() {
            return (
                <Table 
                    {...this.props} 
                
                />
            );
        }
    };
}

useRowClick.displayName = 'useRowClick';
useRowClick.dependence = [];
useRowClick.hooks = function(){
    return {
        setClickedRow: rowKey => {
            this.store.clickedRow = rowKey;
            this.setLastCheckedKey(rowKey);
            this.forceUpdate();
        },
        getClickedRow: () => {
            return this.store.clickedRow;
        },
    };
};
useRowClick.propsGenerator = function(props){
    const { rowProps, store } = props;

    return {
        ...props,
        rowProps: (row, viewIndex) => {
            let rawRowProps = rowProps?.(row, viewIndex);

            return {
                ...rawRowProps,
                className: classnames(rawRowProps.className, { 'selected-row': row.key === store.getClickedRow() },
                ),
                onClick: e => {
                    // TODO:这里可以用e.persist()优化
                    let myEvent = { ...e };
                    Object.setPrototypeOf(myEvent, Object.getPrototypeOf(e));

                    myEvent?.stopPropagation();
                    clearTimeout(timer);

                    if (rawRowProps?.onDoubleClick) {
                        timer = setTimeout(function(){
                            store.batchUpdate(() => {
                                store.setClickedRow(row.key);
                                rawRowProps?.onClick?.(myEvent);
                            });
                        }, 300);
                    } else {
                        timer = null;
                        if(!e.ctrlKey){
                            store.setClickedRow(row.key); //卡片表格不触发选择事件
                            rawRowProps?.onClick?.(myEvent);
                        }
                    }
                },
                onDoubleClick: e => {
                    clearTimeout(timer);
                    
                    store.setClickedRow(row.key);
                    rawRowProps?.onDoubleClick?.(e);
                },
            };
        },
    };
};